import React from 'react';
const CheckOutIcon = () => {
    return <svg width="14" height="10" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11.7803 0.96967C12.0732 1.26256 12.0732 1.73744 11.7803 2.03033L5.28033 8.53033C4.98744 8.82322 4.51256 8.82322 4.21967 8.53033L0.96967 5.28033C0.676777 4.98744 0.676777 4.51256 0.96967 4.21967C1.26256 3.92678 1.73744 3.92678 2.03033 4.21967L4.75 6.93934L10.7197 0.96967C11.0126 0.676777 11.4874 0.676777 11.7803 0.96967Z" fill="var(--color-primary)" />
    </svg>
};

export default CheckOutIcon;

